import clsx from "clsx";
import { Filters } from "../../../lib/filters";
import { PeopleHorizontalFilters } from "../../../lib/filters/accordion/horizontalFiltersPerson";
import { ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../lib/filters/dto";
import { useAppSelector } from "../../../lib/redux/hooks";
import { ProjectDTO } from "../../projects/dto";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../projects/mails/dto";
import { ContactsCounterDTO } from "../contacts/dto";
import { TargetListDTO } from "../dto";
import { TargetPeopleList } from "../editTargetListDetails/people/list/list";

interface Props {
    toActivate: number
    showPopup: boolean
    setShowPopup: (action: boolean) => void
    selectedIds: { contactId: string, personId: string }[]
    setSelectedIds: (action: { contactId: string, personId: string }[]) => void
    filters: FindAllContactsFilters
    setPage: (action: number) => void
    setFilters: (action: Partial<FindAllContactsFilters>) => void
    resetFilters: () => void
    contacts: FindContactsTargetResponse<ContactType.PERSON>
    counters: ContactsCounterDTO
    targetList: TargetListDTO
    project: ProjectDTO
    isLoadingEmailsHistory: boolean
    emailsHistory: { messages: EmailsMessagesDTO[] }
    templates: FindAllCustomMailsResponseDTO
}

export function TargetPeopleBins(props: Props) {
    const { selectedIds, setSelectedIds, counters, project, setShowPopup, showPopup, templates, filters, setFilters, setPage, resetFilters, contacts, toActivate, targetList, isLoadingEmailsHistory, emailsHistory } = props
    const databaseState = useAppSelector(state => state.database)

    return (
        <div className="max-h-full w-full flex h-full">
            <div className="flex w-full">
                <div
                    className={clsx("transition-all duration-300 w-[20%] h-full opacity-100 rounded-bl-xl", {
                        flex: databaseState.filtersActive,
                        hidden: !databaseState.filtersActive,
                    })}
                >
                    <Filters
                        section="target-bin"
                        contactType={ContactType.PERSON}
                        isInTargetList
                        resetFilters={function (): void {
                            resetFilters()
                        }} filters={filters}
                        updateFilters={function (newFilters: Partial<FindAllContactsFilters>): void {
                            setFilters(newFilters)
                        }} />
                </div>
                <div
                    className={clsx({
                        "w-full": !databaseState.filtersActive,
                        "w-4/5": databaseState.filtersActive,
                    })}
                >
                    <div className="h-full">
                        <PeopleHorizontalFilters
                            onChangeFilters={f => setFilters({ ...filters, ...f, page: 0 })}
                            filters={filters}
                            toActivate={toActivate}
                            isInTargetList={true}
                        />
                        <TargetPeopleList
                            section="target-bin"
                            templates={templates}
                            isLoadingEmailsHistory={isLoadingEmailsHistory}
                            emailsHistory={emailsHistory}
                            project={project}
                            targetList={targetList}
                            counters={counters}
                            contacts={contacts}
                            selectedIds={selectedIds}
                            setSelectedIds={arg => setSelectedIds(arg)}
                            setShowPopup={arg => setShowPopup(arg)}
                            showPopup={showPopup}
                            filters={filters}
                            setFilters={function (action: Partial<FindAllContactsFilters>): void {
                                setFilters(action)
                            }} setPage={function (action: number): void {
                                setPage(action)
                            }} resetFilters={function (): void {
                                resetFilters()
                            }} />
                    </div>
                </div>
            </div>
        </div>
    )
}